/**
 * Accepts opaque hex API tokens (local register) and JWT / other bearer tokens from external login.
 */
export function isValidApiToken(value) {
  if (value == null || typeof value !== 'string') return false;
  const t = value.trim();
  if (!t || t === 'undefined' || t === 'null') return false;
  if (/^[a-f0-9]{32,128}$/i.test(t)) return true;
  if (/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(t)) return true;
  return t.length >= 16;
}

export function readStoredApiToken() {
  try {
    const raw = localStorage.getItem('token');
    if (!isValidApiToken(raw)) {
      if (raw) localStorage.removeItem('token');
      return null;
    }
    return raw.trim();
  } catch {
    return null;
  }
}
